"use client";

import NavbarList from "./NavbarList";
import Lang from "./Lang";
import { Button } from "@/components/ui/button";
import Magnet from "@/animations/Magnet";
import useScrollTrigger from "@/hooks/useScrollTrigger";
import { cn } from "@/lib/cn";
import { MAGNET_PADDING, MAGNET_STRENGTH } from "@/utils/constants";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { FaBars } from "react-icons/fa";
import { useState } from "react";
import NavbarMobileSidebar from "./Mobile/NavbarMobileSidebar";
import { AnimatedThemeToggler } from "@/components/magicui/animated-theme-toggler";

const baseClasses =
  "ease-in-out bg-light w-full z-50 xl:sticky dark:bg-input/30 dark:shadow-none dark:backdrop-blur-sm ";
const scrolledClasses =
  "shadow-lg animate_from_top_nav sticky w-full top-0 z-50";

const Navbar = () => {
  const isScrolled = useScrollTrigger(50);
  const t = useTranslations();
  const [open, setOpen] = useState(false);

  const toggleSidebar = () => setOpen((prev) => !prev);

  return (
    <>
      <nav className={cn(baseClasses, isScrolled ? scrolledClasses : "")}>
        <div className="container py-6 flex items-center justify-between">
          {/* LOGO */}
          <Link href="/" prefetch>
            <h1 className="text-3xl font-bold">{t("Ramy")}</h1>
          </Link>

          {/* DESKTOP */}
          <div className="hidden xl:flex items-center justify-between w-full">
            {/* NAVBAR */}
            <NavbarList />

            <div className="flex items-center gap-5">
              {/* SWITCH THEME */}
              <AnimatedThemeToggler />

              {/* LANGUAGES */}
              <Lang />

              {/* HIRE ME */}
              <Magnet
                padding={MAGNET_PADDING}
                disabled={false}
                magnetStrength={MAGNET_STRENGTH}
              >
                <Link href="/#Contact">
                  <Button aria-label={t("Hire Me")}>{t("Hire Me")}</Button>
                </Link>
              </Magnet>
            </div>
          </div>

          {/* MOBILE */}
          <div className="xl:hidden flex items-center justify-between">
            <div className="flex items-center gap-5">
              {/* SWITCH THEME */}
              <AnimatedThemeToggler />

              {/* BAR */}
              <FaBars
                onClick={toggleSidebar}
                className="text-4xl cursor-pointer"
              />
            </div>
          </div>
        </div>
      </nav>
      {/* MOBILE SIDEBAR */}
      {open && <NavbarMobileSidebar toggleSidebar={toggleSidebar} />}
    </>
  );
};

export default Navbar;
